<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<p class="ct" id="toc_marker-3"><a class="calibre22" id="Contents-A"></a>Contents</p>
</div>
<div class="basic-text-frame">
<p class="ct"></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed#toc_marker-1">Gentlemen Formerly Dressed</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed1#toc_marker-2">Copyright</a></p>
<p class="contents-entry"><a href="#/OEBPS/#toc_marker-3">Contents</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed3#toc_marker-4">Chapter One</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed4#toc_marker-5">Chapter Two</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed5#toc_marker-6">Chapter Three</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed6#toc_marker-7">Chapter Four</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed7#toc_marker-8">Chapter Five</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed8#toc_marker-9">Chapter Six</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed9#toc_marker-10">Chapter Seven</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed10#toc_marker-11">Chapter Eight</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed11#toc_marker-12">Chapter Nine</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed12#toc_marker-13">Chapter Ten</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed13#toc_marker-14">Chapter Eleven</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed14#toc_marker-15">Chapter Twelve</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed15#toc_marker-16">Chapter Thirteen</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed16#toc_marker-17">Chapter Fourteen</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed17#toc_marker-18">Chapter Fifteen</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed18#toc_marker-19">Chapter Sixteen</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed19#toc_marker-20">Chapter Seventeen</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed20#toc_marker-21">Chapter Eighteen</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed21#toc_marker-22">Chapter Nineteen</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed22#toc_marker-23">Chapter Twenty</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed23#toc_marker-24">Chapter Twenty-one</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed24#toc_marker-25">Chapter Twenty-two</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed25#toc_marker-26">Chapter Twenty-three</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed26#toc_marker-27">Chapter Twenty-four</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed27#toc_marker-28">Chapter Twenty-five</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed28#toc_marker-29">Chapter Twenty-six</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed29#toc_marker-30">Chapter Twenty-seven</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed30#toc_marker-31">Chapter Twenty-eight</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed31#toc_marker-32">Chapter Twenty-nine</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed32#toc_marker-33">Chapter Thirty</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed33#toc_marker-34">Chapter Thirty-one</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed34#toc_marker-35">Chapter Thirty-two</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed35#toc_marker-36">Chapter Thirty-three</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed36#toc_marker-37">Chapter Thirty-four</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed37#toc_marker-38">Chapter Thirty-five</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed38#toc_marker-39">Epilogue</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed39#toc_marker-40">Acknowledgments</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed40#toc_marker-41">About Sulari Gentill</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed41#toc_marker-42">More from this Author</a></p>
<p class="contents-entry"><a href="#/OEBPS/Gentlemen_Formerly_Dressed42#toc_marker-43">Contact Us</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Gentlemen_Formerly_Dressed-2.vue?150226c4